// eslint-disable-next-line no-undef
module.exports = require('../dist');



//////////////////
// WEBPACK FOOTER
// ./~/@stripe/stripe-js/lib/index.js
// module id = 500
// module chunks = 0